import { getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBMkCaHEBUte2-_s6s5ZFR1dlpJctnGMtM",
    authDomain: "cachet-blinds.firebaseapp.com",
    projectId: "cachet-blinds",
    storageBucket: "cachet-blinds.appspot.com",
    messagingSenderId: "272860659402",
    appId: "1:272860659402:web:510c91f9e8ab6cb448be33",
    measurementId: "G-ZY89KEE7BC"
};

// Initialize Firebase only if it hasn't been initialized yet
const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];

// Initialize Auth - Firebase v11 handles persistence automatically
const auth = getAuth(app);

// Initialize Firestore
const firestore = getFirestore(app);

export { auth, firestore }; 